import { ChangeControllerSettingsAction } from '../../../../enums/action';

// Mirrors the controller firmware's channel console presets exactly (the
// shunt/machine/phase values it writes to each channel when a console button
// is pressed) - channel numbers here are 1-indexed to match the app's
// channel numbering (the firmware's `it` loop index is 0-indexed).
type ConsoleGroup = { from: number; to: number; shunt: number; machine: number };

export const CONSOLE_PATTERNS: Partial<Record<ChangeControllerSettingsAction, ConsoleGroup[]>> = {
  [ChangeControllerSettingsAction.CHANNEL_CONSOLE_4_6]: [
    { from: 1, to: 6, shunt: 1, machine: 1 },
    { from: 7, to: 12, shunt: 2, machine: 2 },
    { from: 13, to: 18, shunt: 3, machine: 3 },
    { from: 19, to: 24, shunt: 4, machine: 4 },
  ],
  [ChangeControllerSettingsAction.CHANNEL_CONSOLE_2_12]: [
    { from: 1, to: 12, shunt: 1, machine: 1 },
    { from: 13, to: 24, shunt: 3, machine: 3 },
  ],
  [ChangeControllerSettingsAction.CHANNEL_CONSOLE_1_18]: [
    { from: 1, to: 18, shunt: 1, machine: 1 },
    { from: 19, to: 24, shunt: 4, machine: 4 },
  ],
  [ChangeControllerSettingsAction.CHANNEL_CONSOLE_1_12_GEN]: [
    { from: 1, to: 6, shunt: 1, machine: 1 },
    { from: 7, to: 12, shunt: 2, machine: 2 },
    { from: 13, to: 18, shunt: 3, machine: 3 },
    { from: 19, to: 24, shunt: 4, machine: 4 },
  ],
};

// Every console preset sets phase the same way: (it MOD 3) + 1.
export const getExpectedPhase = (channelNumber: number): number => ((channelNumber - 1) % 3) + 1;

const getExpectedShuntMachine = (groups: ConsoleGroup[], channelNumber: number) =>
  groups.find((group) => channelNumber >= group.from && channelNumber <= group.to);

export const channelMatchesConsolePattern = (
  groups: ConsoleGroup[],
  channel: { channelNumber: number; shunt_number: number | null; machine_number: number | null; phase_number: number | null },
): boolean => {
  const expected = getExpectedShuntMachine(groups, channel.channelNumber);

  if (!expected) {
    return true;
  }

  return (
    channel.shunt_number === expected.shunt &&
    channel.machine_number === expected.machine &&
    channel.phase_number === getExpectedPhase(channel.channelNumber)
  );
};
